import {
    CHANNEL_SYNCHRONIZATION_COMPLETE, CLEAR_CURRENT_CHANNEL, FETCH_UNREAD_MESSAGE_INFO, SET_TWILIO_CLIENTS,
    SET_TWILIO_CURRENT_CHANNEL, UPDATE_CONNECTION_STRENGTH,
    UPDATE_TWILIO_ACCESS_TOKEN,
    UPDATE_TWILIO_CHANNEL_INFO, UPDATE_TWILIO_CURRENT_CHANNEL, UPDATE_TWILIO_CURRENT_CHANNEL_WITH_PATIENT,
    UPDATE_TWILIO_LAST_X_CONVERSATIONS,
    UPDATE_TWILIO_TOTAL_UNREAD_COUNT,
    UPDATE_TWILIO_USER_IDENTITY
} from "../actions/ActionTypes"
import initialState from "./InitialState"

export const TwilioContextReducer = (state = initialState.twilioContext, action: any) => {
    switch (action.type) {
        case UPDATE_TWILIO_ACCESS_TOKEN:
            return { ...state, accessToken: action.accessToken }
        case UPDATE_TWILIO_TOTAL_UNREAD_COUNT:
            return { ...state, totalUnreadCount: action.unreadCount }
        case UPDATE_TWILIO_USER_IDENTITY:
            return { ...state, userIdentity: action.userIdentity }
        case UPDATE_TWILIO_CHANNEL_INFO:
            return { ...state, channelInfo: action.channelInfo }
        case UPDATE_TWILIO_CURRENT_CHANNEL:
            return { ...state, currentChannel: { ...state.currentChannel, channelSid: action.channelSid, channel: null } }
        case UPDATE_TWILIO_CURRENT_CHANNEL_WITH_PATIENT:
            return { ...state, patient: action.patient, currentChannel: { ...state.currentChannel, channelSid: action.channelSid, channel: null as any, identity: action.identity } }
        case SET_TWILIO_CURRENT_CHANNEL:
            return { ...state, currentChannel: { ...state.currentChannel, channel: action.channel } }
        case CHANNEL_SYNCHRONIZATION_COMPLETE:
            return { ...state, channelsSynced: action.payload }
        case FETCH_UNREAD_MESSAGE_INFO:
            return { ...state, unreadMessageInfo: action.payload }
        case CLEAR_CURRENT_CHANNEL:
            return { ...state, currentChannel: initialState.twilioContext.currentChannel, patient: null }
        case UPDATE_CONNECTION_STRENGTH:
            return { ...state, connectionStrengthMessage: action.payload }
        case SET_TWILIO_CLIENTS:
            return {...state, clients: action.clientsMap}
        default:
            return state;
    }
}